<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>

    <a-form-item label="微信名称">
      <a-input v-model:value="search.member_name" style="width:220px" placeholder="请输入微信名称进行搜索"></a-input>
    </a-form-item>

    <a-form-item label="商品名称">
      <a-input v-model:value="search.goods_name" style="width:220px" placeholder="请输入商品名称进行搜索"></a-input>
    </a-form-item>

    <a-form-item label="奖项名称">
      <a-input v-model:value="search.award_name" style="width:220px" placeholder="请输入奖项名称进行搜索"></a-input>
    </a-form-item>

    <a-form-item label="收货地址">
      <a-input v-model:value="search.receiv_area" style="width:220px" placeholder="请输入收货地址进行搜索"></a-input>
    </a-form-item>

    <a-form-item label="联系手机">
      <a-input v-model:value="search.receiv_phone" style="width:220px" placeholder="请输入收货人手机号进行搜索"></a-input>
    </a-form-item>

    <!-- <a-form-item label="" name='keywords'>
      <a-input-group compact :style="{width:'360px'}">
        <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
          <a-select-option value="member_name">微信昵称</a-select-option>
          <a-select-option value="award_name">奖项名称</a-select-option>
          <a-select-option value="award_content">奖品名称</a-select-option>
          <a-select-option value="receiv_name">收货人</a-select-option>
          <a-select-option value="receiv_phone">联系手机</a-select-option>
          <a-select-option value="receiv_area">收货地址</a-select-option>
        </a-select>
        <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
      </a-input-group>
    </a-form-item> -->

    <a-form-item label="领奖时间" name='time'>
      <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" v-model:value="time" style="width:220px" />
    </a-form-item>

    <a-form-item label="收货人">
      <a-input v-model:value="search.receiv_name" style="width:220px" placeholder="请输入收货人名称进行搜索"></a-input>
    </a-form-item>

    <a-form-item label="订单号">
      <a-input v-model:value="search.order_no" style="width:220px" placeholder="请输入订单号进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="状 态" name='award_status'>
      <a-select v-model:value="search.award_status" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="0">待发奖</a-select-option>
        <a-select-option :value="1">发放成功</a-select-option>
        <a-select-option :value="2">发放失败</a-select-option>
        <a-select-option :value="3">发放中</a-select-option>
        <a-select-option :value="4">未领取</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
      <a-button class="m-r-10" v-has:marketinOrderExport='exportTable'>导出</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list' :scroll="{ x: 'max-content'}" class="tableFixBox">
    <template v-slot:award_status_title="{ record }">
      <a v-if="record.is_virtual_redeem==1" @click="()=>handeletotal(record)">{{record.award_status_title}}</a>
      <p v-else>{{record.award_status_title}}</p>
    </template>
    <template v-slot:award_info="{ record }">
      <div v-if='record.award_info.length == 1'>
        <div v-for="(item,index) in record.award_info" :key='index'>
          <a-card-meta>
            <template #avatar>
              <img class="table_img" :src="info.picdomain+(item.cover_image_url)" alt="" />
            </template>
            <template #description>
              <p class="s_omit2">{{item.gift_name}}</p>
              <!-- <p class="s_c333">({{record.award_name}})</p> -->
            </template>
          </a-card-meta>
        </div>
      </div>
      <div class="s_flex_ali" v-else>
        <div v-for="(item,index) in record.award_info" :key='index'>
          <img class="m-r-10 table_img" :src="info.picdomain+(item.cover_image_url)" alt=""/>
        </div>
        <p class="s_c333">({{record.award_name}})</p>
      </div>
    </template>
    <template v-slot:receiv_name="{ record }">
      <p>{{record.receiv_name || '-'}}<span v-if='record.receiv_phone'>，{{record.receiv_phone}}</span></p>
      <p v-if='record.receiv_area'>{{record.receiv_area}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a v-has:marketingOrderDetail="()=>{showDetail=true;scan_award_id=record.id;sn_order=record.sn;}" href="javascript:;">详情</a>
      <a-button type="link" @click="orderDeliver(record)" v-if="record.award_status == 0">发货</a-button>
      <a v-has:marketingOrderEditAddress="()=>{showAddress=true;scan_award_id=record.id}" v-if="record.award_status == 0" href="javascript:;">修改地址</a>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal :keyboard="false" title="发货" :width='1000' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
    <entityDeliver :deliverData='deliverData' v-on:submitdeliver='submitdeliver'></entityDeliver>
  </a-modal>
  <a-modal :keyboard="false" centered v-model:visible="isTotal" :width='1200' :footer="null" destroyOnClose>
    <RedeemCode :order_no='order_no'></RedeemCode>
  </a-modal>
  <a-modal title="订单详情" :keyboard="false" centered v-model:visible="showDetail" :width='1000' :footer="null" destroyOnClose :bodyStyle="{'height':'80vh',
  'overflowY': 'scroll'}">
    <orderDetail :scan_award_id='scan_award_id' :sn_order='sn_order' ></orderDetail>
  </a-modal>
  <a-modal :keyboard="false" title="修改收货地址" :width='600' centered :footer="null" v-model:visible="showAddress" destroyOnClose>
    <editAddress :scan_award_id='scan_award_id' v-on:submitaddress='submitAddress'></editAddress>
  </a-modal>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { getPageState } from "@/utils/pageState";
import {
  getEntityList,
  entityawardExport
} from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
import entityDeliver from "./deliver";
import store from "@/store";
import  RedeemCode from "./../../order_list/components/RedeemCode.vue";
import  orderDetail from "./orderDetail";
import  editAddress from "./editAddress";

// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  key_type: "",
  keyword: "",
  start_time: "",
  end_time: "",
  award_status: "",
  is_write: 0,
  order_no: "",
  award_name: "",
  member_name: "",
  goods_name: "",
  receiv_name: "",
  receiv_phone: "",
  receiv_area: "",
};
export default {
  components: { entityDeliver,RedeemCode,orderDetail,editAddress },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let list = ref([]);
    const state = reactive({
      showDetail:false,
      info: store.state.user.info,
      showDeliver: false,
      listLoading: false,
      time: [],
      total: 1,
      deliverData: {},
      isTotal:false,
      order_no:'',
      scan_award_id:"",
      showAddress:false,
      sn_order:"",
    });
    let columns = ref([
      {
        title: "订单号",
        dataIndex: "sn",
        key: "sn",
        align: "center",
      },

      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
        align: "center",
      },
      {
        title: "商品信息",
        dataIndex: "award_info",
        key: "award_info",
        width: 300,
        slots: { customRender: "award_info" },
      },
      {
        title: "领奖时间",
        dataIndex: "receiv_time",
        key: "receiv_time",
        align: "center",
        customRender: ({ record }) => {
          return record.receiv_time ? record.receiv_time : "-";
        },
      },
      {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
        align: "center",
      },
      {
        title: "奖项名称",
        dataIndex: "award_name",
        key: "award_name",
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "award_status_title",
        key: "award_status_title",
        align: "center",
        slots: { customRender: "award_status_title" },
      },
      {
        title: "收货人信息",
        dataIndex: "receiv_name",
        key: "receiv_name",
        slots: { customRender: "receiv_name" },
      },

      {
        title: "操作",
        key: "action",
        fixed: "right",
        align: "center",
        slots: { customRender: "action" },
      },
    ]);
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    //打开发货弹窗
    const orderDeliver = (e) => {
      state.deliverData = e;
      state.showDeliver = true;
    };
    //发货
    const submitdeliver = (e) => {
      state.showDeliver = false;
      initData(search.value);
    };
    const handeletotal = async (e) => {
      state.isTotal = true;
      state.order_no=e.sn;
    };
    //确认修改地址
    const submitAddress = () =>{
      state.showAddress = false;
      initData(search.value);
    }
    //获取列表
    const initData = async (values) => {
      list.value = [];
      state.listLoading = true;
      try {
        let res = await getEntityList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          list.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });
    // 导出
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      var json = JSON.parse(JSON.stringify(search.value));
      let result = await entityawardExport(json)
        .then((res) => res.data)
        .catch((error) => error);
      setTimeout(hide);
      if (iscode(result, true)) {
        window.open(result.data.url);
      }
    };
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      inputSelect,
      orderDeliver,
      submitdeliver,
      exportTable,
      handeletotal,
      submitAddress
    };
  },
};
</script>
